export default "__VITE_ASSET__8cfCHkr7__"